module.exports = __webpack_public_path__ + "img/dashboard.7eec0009.svg";